import { getRequest, postRequest, putRequest } from "./performanceApiClient";

export const listReviews = async (params = {}) =>
  getRequest("/reviews", { params });

export const getReviewById = async (reviewId) =>
  getRequest(`/reviews/${reviewId}`);

export const createReview = async (payload) => postRequest("/reviews", payload);

export const updateReview = async (reviewId, payload) =>
  putRequest(`/reviews/${reviewId}`, payload);

export const submitReview = async (reviewId) =>
  postRequest(`/reviews/${reviewId}/submit`, {});

export const acknowledgeReview = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/acknowledge`, payload);

export const finalizeReview = async (reviewId) =>
  postRequest(`/reviews/${reviewId}/finalize`, {});

export const approveIncrement = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/increment/approve`, payload);

export const approvePromotion = async (reviewId, payload = {}) =>
  postRequest(`/reviews/${reviewId}/promotion/approve`, payload);

export const getReviewAnalytics = async () => getRequest("/reviews/analytics");

export default {
  listReviews,
  getReviewById,
  createReview,
  updateReview,
  submitReview,
  acknowledgeReview,
  finalizeReview,
  approveIncrement,
  approvePromotion,
  getReviewAnalytics,
};
